// removed by extract-text-webpack-plugin
module.exports = {"receipt-refund-reason":"app-components-receipt-transactions-RefundReason-__RefundReason___2gc1j","truncate-refund-reason":"app-components-receipt-transactions-RefundReason-__RefundReason___3N5tf"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/transactions/RefundReason/RefundReason.css
// module id = 2254
// module chunks = 0